'use strict';

var Util = require("../layouts/util.js");
var $$Array = require("bs-platform/lib/js/array.js");
var React = require("react");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var OrganizersModuleScss = require("./organizers.module.scss");

function organizerWithPic(param) {
  var name = param[/* name */0];
  return React.createElement("figure", {
              key: name,
              className: OrganizersModuleScss.organizer
            }, React.createElement("img", {
                  className: OrganizersModuleScss.photo,
                  alt: "Photo of " + (String(name) + ""),
                  src: param[/* imgUrl */1]
                }), React.createElement("figcaption", {
                  className: OrganizersModuleScss.info
                }, React.createElement("h3", {
                      className: OrganizersModuleScss.name
                    }, Util.s(name)), React.createElement("a", {
                      className: OrganizersModuleScss.twitter,
                      href: param[/* href */2]
                    }, Util.s("@"), Util.s(param[/* twitter */3]))));
}

var component = ReasonReact.statelessComponent("Organizers");

function make(organizers, _) {
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function () {
              return React.createElement("div", {
                          className: OrganizersModuleScss.root
                        }, organizers ? $$Array.map(organizerWithPic, $$Array.of_list(organizers)) : null);
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* subscriptions */component[/* subscriptions */13],
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

exports.organizerWithPic = organizerWithPic;
exports.component = component;
exports.make = make;
/* component Not a pure module */



// WEBPACK FOOTER //
// ./src/components/organizers.js